import * as React from 'react';
export const discoverSvg = React.forwardRef(function discoverSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F6F9FC',
        fillRule: 'nonzero',
        d: 'M1 12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v8Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E6EBF1',
        fillRule: 'nonzero',
        d: 'M1 12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v8Zm-1 0V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F78000',
        d: 'M4.41 14.002a25.91 25.91 0 0 0 11.591-5.654v4.359c0 .715-.597 1.295-1.333 1.295H4.41ZM8.501 6c.562 0 .999.44.999.999A.99.99 0 0 1 8.501 8C7.93 8 7.5 7.567 7.5 6.987A.994.994 0 0 1 8.501 6Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#333',
        d: 'M3 6h3a1 1 0 1 1 0 2H3a1 1 0 1 1 0-2Zm8 0h2a1 1 0 0 1 0 2h-2a1 1 0 0 1 0-2Z',
      }),
    ),
  );
});
discoverSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var discover = {
  category: 'card',
  colorable: false,
  name: 'discover',
  svg: discoverSvg,
};
